export default "__VITE_ASSET__Bol73t_H__"